import React from "react";
import { connect } from 'react-redux';
import UserSearch from './userSearch';
import UserProfile from "./userProfile";

const User = (props) => {
    return (
            <>
                {!props.users?.userProfile && <UserSearch/>}
                {props.users?.userProfile && <UserProfile/>}
            </>
    );
};

const mapDispatchToProps = {
};

const mapStateToProps = (state) => {
    const { users } = state.admin;
    return { users };
};

export default connect(mapStateToProps, mapDispatchToProps)(User);